<template>
  <transition name="fade">
    <div id="spinner" v-show="spinData.spinning">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="shape-rendering: auto;" width="80px" height="80px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <circle cx="50" cy="50" r="32" stroke-width="8" stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="round">
          <animateTransform attributeName="transform" type="rotate" dur="2.564102564102564s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
        </circle>
        <circle cx="50" cy="50" r="23" stroke-width="8" stroke-dasharray="36.12831551628262 36.12831551628262" stroke-dashoffset="36.12831551628262" fill="none" stroke-linecap="round">
          <animateTransform attributeName="transform" type="rotate" dur="2.564102564102564s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50;-360 50 50"></animateTransform>
        </circle>
      </svg>
      <p :style="{opacity: spinData.msg ? '1' : '0'}" class="msg">{{spinData.msg}}</p>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'spinner',
  data () {
    return {
      loadingMessages: [
        'Getting our head in the game...',
        'It Doesn\'t Have to Be Pretty...',
        'Not throwing in the towel...',
        'The Ball\'s in our court...',
        'It\'s in our wheelhouse...',
        'Cutting to the basket...',
        'Shooting from long distance...'
      ],
      index: -1
    }
  },
  computed: {
    spinData: function () {
      let spinData = {
        spinning: false,
        msg: ''
      }
      if (this.$store.getters.isLoading) {
        let min = Math.ceil(0);
        let max = Math.floor(this.loadingMessages.length-1);
        let index = Math.floor(Math.random() * (max - min + 1)) + min;
        spinData = {
          spinning: true,
          msg: this.loadingMessages[index]
        }
      }
      return spinData
    },
  },
  methods: {
  }
}
</script>
<style src="./spinner.styl" lang="stylus" scoped></style>
